import type { oz } from '@weft/utils';
import { IntegrationSchema } from './integration-schema';
import { OAuth2DataSchema } from './oauth/oauth2-data-schema';

export const OAuth2IntegrationSchema = IntegrationSchema.extend({
  oAuthData: OAuth2DataSchema,
}).openapi('OAuth2Integration');

export type OAuth2Integration = oz.infer<typeof OAuth2IntegrationSchema>;
